var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.22 6.54999H5.78C5.5 6.54999 5.24 6.55999 5 6.56999C2.63 6.70999 2 7.57999 2 10.28V10.86C2 11.41 2.45 11.86 3 11.86H18C18.55 11.86 19 11.41 19 10.86V10.28C19 7.29999 18.24 6.54999 15.22 6.54999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.36C2.45 13.36 2 13.81 2 14.36V17.27C2 20.25 2.76 21 5.78 21H15.22C18.19 21 18.97 20.28 19 17.43V14.36C19 13.81 18.55 13.36 18 13.36H3ZM6.96 18.56H5.25C4.84 18.56 4.5 18.22 4.5 17.81C4.5 17.4 4.84 17.06 5.25 17.06H6.97C7.38 17.06 7.72 17.4 7.72 17.81C7.72 18.22 7.38 18.56 6.96 18.56ZM12.55 18.56H9.11C8.7 18.56 8.36 18.22 8.36 17.81C8.36 17.4 8.7 17.06 9.11 17.06H12.55C12.96 17.06 13.3 17.4 13.3 17.81C13.3 18.22 12.97 18.56 12.55 18.56Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.33V8.08998C22 4.95998 20.21 3.59998 17.51 3.59998H8.57999C7.81999 3.59998 7.13999 3.70998 6.53999 3.93998C6.06999 4.10998 5.64999 4.35998 5.30999 4.68998C5.12999 4.85998 5.26999 5.13998 5.52999 5.13998H16.4C18.65 5.13998 20.47 6.95998 20.47 9.20998V16.38C20.47 16.63 20.74 16.77 20.92 16.59C21.61 15.86 22 14.79 22 13.33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.3f4282e7bf3378285591b471791e197a.svg";
export { ForwardRef as ReactComponent };